import React from "react";
const Answer=(props)=>{
    return(
        
        // <div className="bg-lightbg2 px-2 py-2 rounded-md text-white my-2 w-max max-w-[120vh]">dangerouslySetInnerHTML={{ __html: props.text }}</div>
        <div
        dangerouslySetInnerHTML={{ __html: props.text }} />
    )
}
export default Answer;